import Draggable from "react-draggable";
import LoadingOverlay from "react-loading-overlay";
import { useSelector } from "react-redux";
import Loader from "../../common/components/Loader";

const VoiceVideoPortal = ({ tableComponent, heading, onCancel, isImage = false }) => {
    const { getAssetVoiceNotesResponseLoading } = useSelector(state => state.assetSurveyProjectReducer);
    return (
        <div
            className="modal assign-init-modal "
            style={{ display: "block" }}
            id="modalId"
            tabIndex="-1"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
        >
            <Draggable handle=".draggable" cancel=".non-draggable">
                <div className="modal-dialog assignModal voice-note-modal" role="document">
                    <div className="modal-content">
                        <div className="modal-header draggable">
                            <h5 className="modal-title" id="exampleModalLabel">
                                <div className="txt-hed">{heading ?? ""}</div>
                            </h5>
                            <button type="button" className="close non-draggable" onClick={onCancel}>
                                <span aria-hidden="true">
                                    <img src="/img/close.svg" alt="" />
                                </span>
                            </button>
                        </div>
                        <div className="modal-body ">
                            <LoadingOverlay active={getAssetVoiceNotesResponseLoading} fadeSpeed={10} spinner={<Loader />}>
                                <div className="dashboard-outer">
                                    <div className="outer-detail">
                                        <div className="right-panel-section">
                                            {isImage ? (
                                                tableComponent
                                            ) : (
                                                <div className="dtl-sec  col-md-12 ">
                                                    <div className="tab-dtl region-mng">{tableComponent}</div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </LoadingOverlay>
                        </div>
                    </div>
                </div>
            </Draggable>
        </div>
    );
};

export default VoiceVideoPortal;
